<template>
  <Breadcrumbs
      title="Edit Item"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Items', path: '/items' },
      { label: 'Edit Item', path: '/edit-item/' + $route.params.id },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <editItemForm/>
    </div>
  </div>
</template>

<script>
import editItemForm from "@/pages/master_data/items/items/editItemForm.vue";

export default {
  name: 'editItem',
  components: {
    editItemForm,
  },
}
</script>
